import { colors } from "@styles/colors";
import { View, XStack, YStack, Text } from "tamagui";
import { IconType } from "react-icons";

interface SectionHeaderProps {
  icon: IconType;
  iconColor: string;
  iconBg: string;
  title: string;
  badge?: string;
  badgeColor?: string;
  badgeBg?: string;
  count: number;
  hint?: string;
  /**
   * "light"：這個區塊標題落在頁面頂端的藍色帶上（V2 的第一個區塊），整組轉白。
   * 灰字（grayDark／gray）壓在藍底上對比不足，說明那行幾乎讀不到。
   * 用詞與 SectionLabel 的 tone 一致。
   */
  tone?: "dark" | "light";
}

export const CouponSectionHeader = ({
  icon: Icon,
  iconColor,
  iconBg,
  title,
  badge,
  badgeColor,
  badgeBg,
  count,
  hint,
  tone = "dark",
}: SectionHeaderProps) => {
  const light = tone === "light";
  return (
    <YStack mb="$2.5">
      <XStack ai="center" gap="$2" mb={hint ? "$1.5" : "$2.5"} px="$1">
        <View
          w={22}
          h={22}
          br={7}
          bg={light ? "rgba(255,255,255,0.22)" : iconBg}
          ai="center"
          jc="center"
          flexShrink={0}
        >
          <Icon color={light ? "#fff" : iconColor} size={12} />
        </View>
        <Text fontSize={13} fow="700" color={light ? "#fff" : colors.grayDark}>
          {title}
        </Text>
        {badge && (
          <View bg={light ? "rgba(255,255,255,0.25)" : badgeBg} px="$2" py="$0.5" br={7}>
            <Text fontSize={9} fow="700" color={light ? "#fff" : badgeColor}>
              {badge}
            </Text>
          </View>
        )}
        <Text fontSize={11} color={light ? "rgba(255,255,255,0.85)" : colors.gray} ml="auto">
          {count} 張
        </Text>
      </XStack>
      {hint && (
        <Text fontSize={11} color={light ? "rgba(255,255,255,0.85)" : colors.gray} px="$1" lineHeight={16}>
          {hint}
        </Text>
      )}
    </YStack>
  );
};
